import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appPreventLongNames]',
  standalone: true,
})
export class PreventLongNamesDirective {
  @Output() invalidNameLength = new EventEmitter<string>();

  private readonly maxLength = 30;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ];

    if (allowedKeys.includes(event.key)) {
      return;
    }

    if (input.value.length >= this.maxLength) {
      event.preventDefault();
      this.invalidNameLength.emit(
        `El nombre no puede superar los ${this.maxLength} caracteres`,
      );
    }
  }
}
